var _a, _b, _c, _d, _e, _f;
import { TABLET_WIDTH } from "@codex/utils/constants";
var styles = (_a = {
        root: {
            width: 462,
            height: 425,
            backgroundColor: "#ffffff"
        },
        title: {
            fontFamily: "Assistant Extra Bold",
            paddingTop: 47,
            fontSize: 34,
            fontWeight: 800,
            fontStyle: "normal",
            fontStretch: "normal",
            lineHeight: 0.65,
            letterSpacing: "normal",
            textAlign: "center",
            color: "#4bb0dd"
        },
        codeError: {
            color: '#f5222d',
            textAlign: 'center',
            margin: '-18px 0 20px'
        },
        subTitle: {
            fontFamily: "Assistant Bold",
            fontSize: 20,
            fontWeight: "bold",
            fontStyle: "normal",
            fontStretch: "normal",
            lineHeight: 1.1,
            letterSpacing: "normal",
            textAlign: "center",
            color: "#5a5a6c"
        },
        input: {
            width: 54,
            height: 54,
            fontSize: 30,
            // padding: 17,
            borderRadius: 6,
            border: "solid 1px #4bb0dd",
            backgroundColor: "#ffffff"
        },
        link: {
            width: 52,
            height: 18,
            fontFamily: "Assistant",
            fontSize: 14,
            fontWeight: "bold",
            fontStyle: "normal",
            fontStretch: "normal",
            lineHeight: "normal",
            letterSpacing: "normal",
            textAlign: "right",
            color: "#4bb0dd"
        },
        text: {
            height: 36,
            fontFamily: 'Assistant',
            fontSize: 16,
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 1.25,
            letterSpacing: 'normal',
            textAlign: 'right',
            color: '#4bb0dd',
            // cursor: 'pointer',
            textDecoration: 'underline',
            '&:active': {
                color: '#096dd9'
            }
        },
        centerText: {
            display: 'flex',
            justifyContent: 'center'
        },
        codeContainer: (_b = {
                display: "flex",
                flexDirection: "row",
                direction: 'rtl',
                justifyContent: "space-evenly",
                margin: "58px 0px 28px"
            },
            _b['& .anticon'] = {
                display: 'none',
            },
            _b['& .ant-form-explain'] = {
                position: 'absolute',
                top: 55,
                width: 300,
            },
            _b['& .ant-form-item'] = {
                height: 57,
                marginRight: 30
            },
            _b['& .ant-input'] = {
                paddingRight: '18px !important'
            },
            _b['& .ant-form-item:first-child'] = {
                marginRight: 0
            },
            _b['& .ant-form'] = {
                height: 57,
            },
            _b),
        btn: (_c = {
                width: 210,
                height: 43,
                borderRadius: 25.4,
                display: "block",
                margin: "0 auto"
            },
            _c["& span"] = {
                fontSize: 16,
                fontWeight: "bold",
                fontStyle: "normal",
                fontStretch: "normal",
                lineHeight: "normal",
                letterSpacing: "normal",
                textAlign: "center",
                color: "#ffffff"
            },
            _c),
        veifyBtn: (_d = {
                backgroundColor: "#f2648b"
            },
            _d["&:hover"] = {
                backgroundColor: "#f2648b"
            },
            _d["&:focus"] = {
                backgroundColor: "#f2648b"
            },
            _d),
        resendBtn: (_e = {
                marginTop: 20,
                backgroundColor: "#4bb0dd"
            },
            _e["&:hover"] = {
                backgroundColor: "#4bb0dd"
            },
            _e["&:focus"] = {
                backgroundColor: "#4bb0dd"
            },
            _e)
    },
    _a["@media screen and (max-width:" + TABLET_WIDTH + "px)"] = {
        root: {
            width: 320,
            height: 340,
        },
        title: {
            paddingTop: 28,
            marginBottom: 15,
        },
        subTitle: {
            fontSize: 18,
            fontFamily: 'Assistant',
            lineHeight: 1.22,
        },
        text: {
            height: 30,
        },
        codeContainer: (_f = {
                margin: '45px 0px 20px'
            },
            _f['& .ant-form-item'] = {
                marginRight: 21
            },
            _f)
    },
    _a);
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/components/PinCodeForm/styles.ts
// module id = 840
// module chunks = 0